import create from 'zustand';
import { storeWithModal } from '../../Agreement/Provider/storeStates';

const rowKey = 'userId';
export const useEngageRolesStore = create(set => storeWithModal(set, rowKey));
